import React from 'react';
import { Typography } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/WarningRounded';
import { Divider, Popover, Whisper } from 'rsuite';
import './WarningIconWithTooltip.scss';

/**
 * @param {{ tooltipWarnings: string[], placement: string|undefined, colorHex: string? }} param0
 */
const WarningIconWithTooltip = ({ tooltipWarnings, placement = 'top', colorHex = '#ffcc00' }) => {
    const tooltipWarningsCount = tooltipWarnings.length;
    const popoverContent = (
        <Popover className="warning-tooltip">
            {tooltipWarnings.map((warning, index) => (
                <Typography>
                    {warning}
                    {
                        ((tooltipWarningsCount > 1 && index + 1 !== tooltipWarningsCount) && (
                            <Divider />
                        ))
                    }
                </Typography>
            ))}
        </Popover>
    );
    return (
        <Whisper
            speaker={popoverContent}
            placement={placement}
            preventOverflow
        >
            <WarningIcon
                className="warning-icon"
                style={{ color: colorHex }}
            />
        </Whisper>
    );
};

export default WarningIconWithTooltip;
